export type DaemonAccountUser = {
  username?: string;
  name?: string;
};

export type DaemonAccountInfo = {
  configured: boolean;
  user?: DaemonAccountUser;
};

type DaemonAccountResponse = {
  configured?: boolean;
  user?: DaemonAccountUser;
};

function normalizeBaseURL(value?: string) {
  return String(value || "").trim().replace(/\/+$/, "");
}

export async function fetchDaemonAccount(baseURL?: string, timeoutMs = 3500): Promise<DaemonAccountInfo | null> {
  const normalized = normalizeBaseURL(baseURL);
  if (!normalized) return null;

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(`${normalized}/api/v1/auth/daemon-account`, {
      method: "GET",
      headers: { Accept: "application/json" },
      signal: controller.signal,
    });
    if (!response.ok) return null;
    const payload = (await response.json()) as DaemonAccountResponse;
    return {
      configured: !!payload?.configured,
      user: payload?.user,
    };
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}

export function daemonAccountDisplayName(account: DaemonAccountInfo | null | undefined): string {
  const name = String(account?.user?.name || "").trim();
  if (name) return name;
  return String(account?.user?.username || "").trim();
}
